module.exports = __webpack_public_path__ + "static/media/1.c8d6e661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/about/1.jpg
// module id = 687
// module chunks = 0